import React from 'react';

import { useSoyuzData } from '@spotahome/soyuz/client';
import { ThemeProvider } from '@spotahome/ui-library';

import RefereeContainer from './RefereeContainer';

const RefereePage = () => {
  const { [RefereePage.NAME]: requestedData } = useSoyuzData();
  const { loggedIn } = requestedData;

  return (
    <ThemeProvider flags={{ newButtons: true }}>
      <RefereeContainer loggedIn={loggedIn} />;
    </ThemeProvider>
  );
};

RefereePage.NAME = 'RefereePageName';

RefereePage.requestData = req => ({
  data: {
    loggedIn: !!req.getAccessToken()
  }
});

export default RefereePage;
